<div class="wrapper">
    <div class="row table-toolbar">
        <div class="cal-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div class="advancedSearch">
                <button type="button" mat-raised-button>
                    <span><mat-icon svgIcon="filter"></mat-icon></span>
                    <span>Advanced Search</span> 
                </button>
            </div>

        </div>
        <div class="cal-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-paginator #weekStatusPaginator [length]="page_length" [pageSize]="items_per_page" [pageSizeOptions]="PAGE_SIZE_OPTIONS_DATA" (page)="handlePage($event)"></mat-paginator>
        </div>
        <div class="cal-xl-2 col-lg-2 col-md-12 col-sm-12">
            <div class="button-group">
                <!-- <button type="button" class="btn-int-blue" mat-raised-button>Apply Leave</button> -->
            </div>
        </div>
    </div>
    <div class="row">
        <div class="cal-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="mat-table-responsive ">
                <table mat-table [dataSource]="weekStatusDataSource">

                    <ng-container matColumnDef="org_name">
                        <th mat-header-cell *matHeaderCellDef> Organization </th>
                        <td mat-cell *matCellDef="let element"> {{element.org_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef> Logged In </th>
                        <td mat-cell *matCellDef="let element"> {{(element.type == "1")? "Desk App" :"Web"}} </td>
                    </ng-container>

                    <ng-container matColumnDef="event_type">
                        <th mat-header-cell *matHeaderCellDef> Event Type </th>
                        <td mat-cell *matCellDef="let element"> {{(element.event_type == "1")? "Clock In" :"Clock Out"}} </td>
                    </ng-container>

                    <ng-container matColumnDef="working_on">
                        <th mat-header-cell *matHeaderCellDef> Worked on</th>
                        <td mat-cell *matCellDef="let element">{{ element?.working_on}}</td>
                    </ng-container>

                    <ng-container matColumnDef="event_date_time">
                        <th mat-header-cell *matHeaderCellDef> Date & Time </th>
                        <td mat-cell *matCellDef="let element"> {{element.event_date_time}} </td>
                    </ng-container>

                    <ng-container matColumnDef="event_location">
                        <th mat-header-cell *matHeaderCellDef> Location </th>
                        <td mat-cell *matCellDef="let element"> {{(element.event_location != null || element.event_location != "")?element.event_location : " - "}} </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="weekStatusDisplayedColumns | tableShowColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: weekStatusDisplayedColumns | tableShowColumns;"></tr>
                </table>
                <ng-container *ngIf="weekStatusDataSource?.filteredData?.length == 0">
                    <div class="row forNoRecords">
                        <h3 class="table-no-date"> No Record found</h3>
                    </div>
                </ng-container>
                <app-table-loader></app-table-loader>
            </div>

        </div>
    </div>
</div>